/**
 * Lazy HTTP log transport — resolves system-api host on each send
 * (env may be missing at module load). Request 0061.
 */

import {
  createHttpLogTransport,
  LogTransportError,
  type LogTransport,
} from '@rammetec/core'
import { env } from '@/config/env'
import { authService } from '@/authService'

export function createConsoleLogHttpTransport(): LogTransport {
  let cachedUrl: string | null = null
  let cached: LogTransport | null = null

  function resolveInner(): LogTransport {
    const host = env.systemApiUrl?.replace(/\/$/, '')
    if (!host) {
      throw new LogTransportError('VITE_SYSTEM_API_URL is not configured', false)
    }
    const url = `${host}/log/v1/ingest`
    if (!cached || cachedUrl !== url) {
      cachedUrl = url
      cached = createHttpLogTransport({
        url,
        getToken: () => authService.getIdToken(),
      })
    }
    return cached
  }

  return {
    async send(records, opts) {
      return resolveInner().send(records, opts)
    },
  }
}
